import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/button/copy.button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/button/download.button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/author-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/comment-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/common/error-message.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/common/fallback-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/scroll-container.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/common/tran.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/like/like-and-dislike.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/schematic/delete-schematic.button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/schematic/take-down-schematic.button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/tag/tag-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EllipsisButton"] */ "/vercel/path0/components/ui/ellipsis-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["toast","error"] */ "/vercel/path0/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/user/id-user-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","List","displayName","Trigger","Content"] */ "/vercel/path0/node_modules/.pnpm/@radix-ui+react-tabs@1.1.12_@types+react-dom@18.3.7_@types+react@18.3.23__@types+react@18.3.2_27upkvizly6w6lrgqrb3dq7f2e/node_modules/@radix-ui/react-tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_babel-plugin-react-compiler@19.0.0-beta-e993439-20250328_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_babel-plugin-react-compiler@19.0.0-beta-e993439-20250328_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_babel-plugin-react-compiler@19.0.0-beta-e993439-20250328_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
